import { render, staticRenderFns } from "./compare.vue?vue&type=template&id=214ccd76&"
import script from "./compare.vue?vue&type=script&lang=js&"
export * from "./compare.vue?vue&type=script&lang=js&"
import style0 from "./compare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports